const DEBUG_SECTIONS = process.env.NODE_ENV === "development";
// Se quiser forçar manualmente, use:
// const DEBUG_SECTIONS = true;

export default function Section({ name, children }) {
  return (
    <section style={{ position: "relative" }}>
      {DEBUG_SECTIONS && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 9999,
            background: "rgba(7, 6, 6, 0.65)",
            color: "#d4e725ff",
            fontSize: "12px",
            padding: "4px 8px",
            fontFamily: "monospace",
          }}
        >
          {name}
        </div>
      )}

      {children}
    </section>
  );
}
